import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-background" />
      
      <div className="container">
        
        {/* Main Footer Content */}
        <div className="footer-main">
          
          {/* Brand Section */}
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="footer-logo-icon">
                <i className="ri-shield-keyhole-line"></i>
              </div>
              <span className="footer-logo-text">Nuroveli</span>
            </div>
            <p className="footer-brand-description">
              Advanced AI-powered cybersecurity solutions protecting businesses 
              from evolving digital threats with intelligent monitoring and proactive defense.
            </p>
            
            {/* Social Links */}
            <div className="footer-social">
              <a href="https://linkedin.com/company/nuroveli" className="footer-social-link" target="_blank" rel="noopener noreferrer">
                <i className="ri-linkedin-line"></i>
              </a>
              <a href="https://twitter.com/nuroveli" className="footer-social-link" target="_blank" rel="noopener noreferrer">
                <i className="ri-twitter-x-line"></i>
              </a>
              <a href="https://github.com/nuroveli" className="footer-social-link" target="_blank" rel="noopener noreferrer">
                <i className="ri-github-line"></i>
              </a>
              <a href="https://youtube.com/@nuroveli" className="footer-social-link" target="_blank" rel="noopener noreferrer">
                <i className="ri-youtube-line"></i>
              </a>
            </div>
          </div>
          
          {/* Navigation Links */}
          <div className="footer-nav">
            
            {/* Company */}
            <div className="footer-nav-section">
              <h3 className="footer-nav-title">Company</h3>
              <ul className="footer-nav-list">
                <li><Link to="/#home" className="footer-nav-link">Home</Link></li>
                <li><Link to="/#about" className="footer-nav-link">About</Link></li>
                <li><Link to="/#services" className="footer-nav-link">Services</Link></li>
                <li><Link to="/#contact" className="footer-nav-link">Contact</Link></li>
              </ul>
            </div>
            
            {/* Services */}
            <div className="footer-nav-section">
              <h3 className="footer-nav-title">Services</h3>
              <ul className="footer-nav-list">
                <li><Link to="/#services" className="footer-nav-link">Threat Detection</Link></li>
                <li><Link to="/#services" className="footer-nav-link">Security Monitoring</Link></li>
                <li><Link to="/#services" className="footer-nav-link">AI Insights</Link></li>
                <li><Link to="/#services" className="footer-nav-link">Custom Solutions</Link></li>
              </ul>
            </div>
            
            {/* Legal */}
            <div className="footer-nav-section">
              <h3 className="footer-nav-title">Legal</h3>
              <ul className="footer-nav-list">
                <li><Link to="/privacy-policy" className="footer-nav-link">Privacy Policy</Link></li>
                <li><Link to="/terms-of-service" className="footer-nav-link">Terms of Service</Link></li>
              </ul>
            </div>
            
            {/* Contact Info */}
            <div className="footer-nav-section">
              <h3 className="footer-nav-title">Contact</h3>
              <div className="footer-contact-info">
                <div className="footer-contact-item">
                  <i className="ri-map-pin-line"></i>
                  <span>123 Cybersecurity Avenue<br />Silicon Valley, CA 94043</span>
                </div>
                <div className="footer-contact-item">
                  <i className="ri-phone-line"></i>
                  <a href="tel:+15551234567">+1 (555) 123-4567</a>
                </div>
                <div className="footer-contact-item">
                  <i className="ri-mail-line"></i>
                  <a href="mailto:info@nuroveli.com">info@nuroveli.com</a>
                </div>
              </div>
            </div>
            
          </div>
          
        </div>
        
        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              © 2025 Nuroveli. All rights reserved.
            </p>
            <div className="footer-bottom-links">
              <Link to="/privacy-policy" className="footer-bottom-link">Privacy Policy</Link>
              <span className="footer-divider">•</span>
              <Link to="/terms-of-service" className="footer-bottom-link">Terms of Service</Link>
            </div>
          </div>
        </div>
        
      </div>
    </footer>
  );
};

export default Footer;
